<template>
  <div class="areaAddPricemanager">
    <el-form ref="form"
             :model="form"
             inline
             class="table-search-bar"
             label-width="110px">
      <el-form-item label="状态"
                    prop="status">
        <el-select v-model="form.status">
          <el-option v-for="item in typeArr"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提货区域"
                    prop="areaId">
        <el-select v-model="form.areaId"
                   filterable>
          <el-option v-for="item in takeAreaDataArr"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省市区/县"
                    prop="citis">
        <el-cascader :options="citisOptions"
                     v-model="form.citis">
        </el-cascader>
      </el-form-item>
      <el-form-item label="操作时间"
                    prop="time">
        <el-date-picker v-model="form.time"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   @click="handleSearch">搜索</el-button>
        <el-button type="primary"
                   @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData"
              style="width: 100%"
              tooltip-effect="light"
              @selection-change="handleSelectionChange">
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column prop="areaName"
                       label="提货区域"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="cityName"
                       label="省市区/县"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          {{`${scope.row.provinceName}` + `${scope.row.cityName}` + `${scope.row.regionName}`}}
        </template>
      </el-table-column>
      <el-table-column prop="price"
                       label="区域加价">
      </el-table-column>
      <el-table-column prop="status"
                       label="状态">
        <template slot-scope="scope">
          {{scope.row.status===0?'开启':'关闭'}}
        </template>
      </el-table-column>
      <el-table-column prop="updatePerson"
                       label="操作人"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="updateTime"
                       label="操作时间"
                       show-overflow-tooltip
                       width="180px">
      </el-table-column>
      <el-table-column prop="remark"
                       label="备注"
                       show-overflow-tooltip
                       width="180px">
      </el-table-column>
    </el-table>
    <div>
      <el-pagination :page-sizes="[10, 20, 50, 100]"
                     :page-size="paramState.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="paramState.total"
                     :current-page="paramState.pageNo"
                     background
                     @current-change="handleCurrentChange"
                     @size-change="handleSizeChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AjaxSelect from '../../../components/ajaxSelect/index'
import MultiCascader from '../../../components/multiCascader/multi-cascader-base-element/multiCascader'
import HttpUtil from '@/common/HttpUtil'
export default {
  name: 'areaPriceManager',
  components: { AjaxSelect, MultiCascader },
  data () {
    return {
      form: {
        status: '',
        areaId: '',
        citis: [],
        pageNo: 1,
        pageSize: 10
      },
      typeArr: [
        { value: '', label: '全部' },
        { value: 1, label: '关闭' },
        { value: 0, label: '开启' }
      ],
      sizeArr: [
        { value: '', label: '100' },
        { value: 1, label: '500' },
        { value: 2, label: '1000' },
        { value: 3, label: '2000' }
      ],
      citisOptions: [],
      takeAreaDataArr: [],
      checkAll: false,
      multipleSelection: '',
      tableData: [],
      paramState: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    ...mapActions(['getAreaAddPrice', 'getCityInfo', 'getArea', 'changeAddPriceStatus', 'inputAreaPriceList', 'areaPriceListExport']),
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch({ pageNo: 1, pageSize: 10 })
    },
    // 搜索
    handleSearch (params) {
      if (this.form.citis.length > 1) {
        const [provinceId, cityId, regionId] = this.form.citis
        this.form.provinceId = provinceId
        this.form.cityId = cityId
        this.form.regionId = regionId
      } else {
        this.form.provinceId = undefined
        this.form.cityId = undefined
        this.form.regionId = undefined
      }

      this.paramState = {
        ...this.paramState,
        ...this.form,
        ...params,
        timeStart: this.form.time && this.form.time[0],
        timeEnd: this.form.time && this.form.time[1]
      }
      HttpUtil.post('/manage/promotion/region/price/history/list', this.paramState).then(res => {
        if (res && res.data) {
          this.tableData = res.data.list || []
          this.paramState.total = res.data.total || 0
        }
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.handleSearch({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.handleSearch({ pageNo: val })
    },
    formatAreaData (arr) {
      return arr.map(item => ({ value: item.id, label: item.name, children: item.children ? this.formatAreaData(item.children) : null }))
    },
    initCitis () {
      this.getCityInfo().then(res => {
        this.citisOptions = this.formatAreaData(res)
      })
    },
    getAllTakeArea () {
      this.getArea({ areaType: 2 }).then(res => {
        let arr = res.map(item => {
          return { id: item.id, name: item.areaName, isLocation: item.isLocalArea }
        })
        this.takeAreaDataArr = [...arr]
      })
    },
    // 表格选择
    handleSelectionChange (val) {
      this.multipleSelection = val.map(item => item.id)
      if (this.list.length > 0) {
        this.checkAll = this.multipleSelection.length === this.list.length
      }
    }
  },
  computed: {
    ...mapGetters({ list: 'getAreaAddPriceList', listState: 'getAreaAddPriceState' }),
    sizeNumber () {
      const maxNo = Math.ceil(this.listState.total / this.form.pageSize) + 1
      const newArr = [...new Array(maxNo).keys()]
      newArr.shift()
      return newArr
    }
  },
  mounted () {
    this.handleSearch({ pageNo: 1, pageSize: 10 })
    this.initCitis()
    this.getAllTakeArea()
  }
}
</script>

<style  scoped lang="scss">
.area-AddPrice-manager {
  .export-row {
    margin-top: 10px;
  }
  .width100 {
    width: 100px;
  }
}
.picktime-box .el-button--text {
  display: none;
}

.output-box {
  margin-top: 20px;
  text-align: right;
}
.input-page,
.select-page {
  width: 100px;
  margin: 0 10px;
}
.input-page,
.select-page-btn {
  width: 120px;
  margin: 0 15px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
